import { _ as _sfc_main, a as _sfc_main$1 } from "./BAccordionItem.vue_vue_type_script_setup_true_lang-CoqPu-3M.mjs";
import { B as BAlert } from "./BAlert-DRD6Q3cQ.mjs";
import { _ as _sfc_main$2, a as _sfc_main$3 } from "./BAvatarGroup.vue_vue_type_script_setup_true_lang-U1HdwmLV.mjs";
import { _ as _sfc_main$4 } from "./BBadge.vue_vue_type_script_setup_true_lang-DYqYye_z.mjs";
import { _ as _sfc_main$5, a as _sfc_main$6 } from "./BBreadcrumb.vue_vue_type_script_setup_true_lang-U842LCaC.mjs";
import { _ as _sfc_main$7 } from "./BButton.vue_vue_type_script_setup_true_lang-BdSl6KfQ.mjs";
import { _ as _sfc_main$8, a as _sfc_main$9 } from "./BButtonToolbar.vue_vue_type_script_setup_true_lang-B0H92qy_.mjs";
import { _ as _sfc_main$l } from "./BCloseButton.vue_vue_type_script_setup_true_lang-8cgz9_uq.mjs";
import { _ as _sfc_main$a, a as _sfc_main$b, b as _sfc_main$c, c as _sfc_main$e, d as _sfc_main$f, e as _sfc_main$g, f as _sfc_main$i } from "./BCard.vue_vue_type_script_setup_true_lang-CX1FMcek.mjs";
import { _ as _sfc_main$d, a as _sfc_main$h } from "./BCardText.vue_vue_type_script_setup_true_lang-ChfBIS7c.mjs";
import { _ as _sfc_main$j, a as _sfc_main$k } from "./BCarouselSlide.vue_vue_type_script_setup_true_lang-DOIhFGe-.mjs";
import { _ as _sfc_main$n } from "./BCollapse.vue_vue_type_script_setup_true_lang-DvEpGRxZ.mjs";
import { _ as _sfc_main$m } from "./BCol.vue_vue_type_script_setup_true_lang-Z6km4tvj.mjs";
import { _ as _sfc_main$o } from "./BContainer.vue_vue_type_script_setup_true_lang-huspOKEK.mjs";
import { _ as _sfc_main$1i } from "./BRow.vue_vue_type_script_setup_true_lang-Wt1e5hWG.mjs";
import { _ as _sfc_main$p } from "./BDropdown.vue_vue_type_script_setup_true_lang-LMav8a4R.mjs";
import { _ as _sfc_main$q, a as _sfc_main$r, b as _sfc_main$s, c as _sfc_main$t, d as _sfc_main$u, e as _sfc_main$v, f as _sfc_main$w } from "./BDropdownText.vue_vue_type_script_setup_true_lang-Cj-Fx2t1.mjs";
import { _ as _sfc_main$x } from "./BForm.vue_vue_type_script_setup_true_lang-DJtzZUN_.mjs";
import { _ as _sfc_main$A, a as _sfc_main$C } from "./BFormFloatingLabel.vue_vue_type_script_setup_true_lang-DvQgaZRF.mjs";
import { _ as _sfc_main$F, a as _sfc_main$I, b as _sfc_main$P, c as _sfc_main$R } from "./BFormValidFeedback.vue_vue_type_script_setup_true_lang-Ch3fU9dp.mjs";
import { _ as _sfc_main$y, a as _sfc_main$z } from "./BFormCheckboxGroup.vue_vue_type_script_setup_true_lang-BFw7wsON.mjs";
import { _ as _sfc_main$B } from "./BFormFile.vue_vue_type_script_setup_true_lang-B7usYuIr.mjs";
import { _ as _sfc_main$D } from "./BFormGroup.vue_vue_type_script_setup_true_lang-DMeTU5tW.mjs";
import { _ as _sfc_main$E } from "./BFormInput.vue_vue_type_script_setup_true_lang-jvciEcJM.mjs";
import { _ as _sfc_main$G, a as _sfc_main$H } from "./BFormRadioGroup.vue_vue_type_script_setup_true_lang-C8NbWP6Y.mjs";
import { _ as _sfc_main$J, a as _sfc_main$L } from "./BFormSelect.vue_vue_type_script_setup_true_lang-kIC1ys8j.mjs";
import { _ as _sfc_main$K } from "./useFormSelect-Dqzj9Q9_.mjs";
import { _ as _sfc_main$M } from "./BFormSpinbutton.vue_vue_type_script_setup_true_lang-BIJdbkPq.mjs";
import { a as _sfc_main$N, _ as _sfc_main$O } from "./BFormTags.vue_vue_type_script_setup_true_lang-DklJQim4.mjs";
import { _ as _sfc_main$Q } from "./BFormTextarea.vue_vue_type_script_setup_true_lang-DkM0TiJF.mjs";
import { _ as _sfc_main$S } from "./BImg.vue_vue_type_script_setup_true_lang-D-lfs4yb.mjs";
import { _ as _sfc_main$T, a as _sfc_main$U } from "./BInputGroupText.vue_vue_type_script_setup_true_lang-NJLGmSBS.mjs";
import { _ as _sfc_main$V } from "./BLink.vue_vue_type_script_setup_true_lang-BRxz8_Ki.mjs";
import { _ as _sfc_main$W, a as _sfc_main$X } from "./BListGroupItem.vue_vue_type_script_setup_true_lang-lrIdzejW.mjs";
import { B as BModal, _ as _sfc_main$Y } from "./BModalOrchestrator.vue_vue_type_script_setup_true_lang-8xWoSTM5.mjs";
import { _ as _sfc_main$Z, a as _sfc_main$_, b as _sfc_main$$, c as _sfc_main$10, d as _sfc_main$11 } from "./BNavText.vue_vue_type_script_setup_true_lang-BtimVYIK.mjs";
import { _ as _sfc_main$12, a as _sfc_main$13, b as _sfc_main$14, c as _sfc_main$15 } from "./BNavbarToggle.vue_vue_type_script_setup_true_lang-BC8gzfkC.mjs";
import { _ as _sfc_main$16 } from "./BOffcanvas.vue_vue_type_script_setup_true_lang-BoWlBnwp.mjs";
import { _ as _sfc_main$17 } from "./BOverlay.vue_vue_type_script_setup_true_lang-ChDZt_kU.mjs";
import { _ as _sfc_main$18 } from "./BPagination.vue_vue_type_script_setup_true_lang-zRHVG-iF.mjs";
import { _ as _sfc_main$19, a as _sfc_main$1a, b as _sfc_main$1b, c as _sfc_main$1c, d as _sfc_main$1d } from "./BPlaceholderWrapper.vue_vue_type_script_setup_true_lang-BzToaZ06.mjs";
import { _ as _sfc_main$1e } from "./floatingUi-B76xsVek.mjs";
import { _ as _sfc_main$1f } from "./BPopoverOrchestrator.vue_vue_type_script_setup_true_lang-DT9DiFfu.mjs";
import { _ as _sfc_main$1g, a as _sfc_main$1h } from "./BProgress.vue_vue_type_script_setup_true_lang-BjivaLyP.mjs";
import { _ as _sfc_main$1j } from "./BSpinner.vue_vue_type_script_setup_true_lang-DD4fhTVT.mjs";
import { _ as _sfc_main$1l, a as _sfc_main$1m, b as _sfc_main$1p, c as _sfc_main$1q, d as _sfc_main$1r, e as _sfc_main$1s, f as _sfc_main$1t, g as _sfc_main$1x } from "./BTable.vue_vue_type_script_setup_true_lang-DPbNjtGg.mjs";
import { _ as _sfc_main$1n } from "./BTableSimple.vue_vue_type_script_setup_true_lang-BHwMXn1g.mjs";
import { _ as _sfc_main$1k, a as _sfc_main$1o } from "./BTabs.vue_vue_type_script_setup_true_lang-CfXiy_8u.mjs";
import { _ as _sfc_main$1u, a as _sfc_main$1v } from "./BToastOrchestrator.vue_vue_type_style_index_0_lang-DzwoIRAO.mjs";
import { _ as _sfc_main$1w } from "./BTooltip.vue_vue_type_script_setup_true_lang-Do0IxGJx.mjs";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAccordion: _sfc_main,
  BAccordionItem: _sfc_main$1,
  BAlert,
  BAvatar: _sfc_main$2,
  BAvatarGroup: _sfc_main$3,
  BBadge: _sfc_main$4,
  BBreadcrumb: _sfc_main$5,
  BBreadcrumbItem: _sfc_main$6,
  BButton: _sfc_main$7,
  BButtonGroup: _sfc_main$8,
  BButtonToolbar: _sfc_main$9,
  BCard: _sfc_main$a,
  BCardBody: _sfc_main$b,
  BCardFooter: _sfc_main$c,
  BCardGroup: _sfc_main$d,
  BCardHeader: _sfc_main$e,
  BCardImg: _sfc_main$f,
  BCardSubtitle: _sfc_main$g,
  BCardText: _sfc_main$h,
  BCardTitle: _sfc_main$i,
  BCarousel: _sfc_main$j,
  BCarouselSlide: _sfc_main$k,
  BCloseButton: _sfc_main$l,
  BCol: _sfc_main$m,
  BCollapse: _sfc_main$n,
  BContainer: _sfc_main$o,
  BDropdown: _sfc_main$p,
  BDropdownDivider: _sfc_main$q,
  BDropdownForm: _sfc_main$r,
  BDropdownGroup: _sfc_main$s,
  BDropdownHeader: _sfc_main$t,
  BDropdownItem: _sfc_main$u,
  BDropdownItemButton: _sfc_main$v,
  BDropdownText: _sfc_main$w,
  BForm: _sfc_main$x,
  BFormCheckbox: _sfc_main$y,
  BFormCheckboxGroup: _sfc_main$z,
  BFormDatalist: _sfc_main$A,
  BFormFile: _sfc_main$B,
  BFormFloatingLabel: _sfc_main$C,
  BFormGroup: _sfc_main$D,
  BFormInput: _sfc_main$E,
  BFormInvalidFeedback: _sfc_main$F,
  BFormRadio: _sfc_main$G,
  BFormRadioGroup: _sfc_main$H,
  BFormRow: _sfc_main$I,
  BFormSelect: _sfc_main$J,
  BFormSelectOption: _sfc_main$K,
  BFormSelectOptionGroup: _sfc_main$L,
  BFormSpinbutton: _sfc_main$M,
  BFormTag: _sfc_main$N,
  BFormTags: _sfc_main$O,
  BFormText: _sfc_main$P,
  BFormTextarea: _sfc_main$Q,
  BFormValidFeedback: _sfc_main$R,
  BImg: _sfc_main$S,
  BInput: _sfc_main$E,
  BInputGroup: _sfc_main$T,
  BInputGroupText: _sfc_main$U,
  BLink: _sfc_main$V,
  BListGroup: _sfc_main$W,
  BListGroupItem: _sfc_main$X,
  BModal,
  BModalOrchestrator: _sfc_main$Y,
  BNav: _sfc_main$Z,
  BNavForm: _sfc_main$_,
  BNavItem: _sfc_main$$,
  BNavItemDropdown: _sfc_main$10,
  BNavText: _sfc_main$11,
  BNavbar: _sfc_main$12,
  BNavbarBrand: _sfc_main$13,
  BNavbarNav: _sfc_main$14,
  BNavbarToggle: _sfc_main$15,
  BOffcanvas: _sfc_main$16,
  BOverlay: _sfc_main$17,
  BPagination: _sfc_main$18,
  BPlaceholder: _sfc_main$19,
  BPlaceholderButton: _sfc_main$1a,
  BPlaceholderCard: _sfc_main$1b,
  BPlaceholderTable: _sfc_main$1c,
  BPlaceholderWrapper: _sfc_main$1d,
  BPopover: _sfc_main$1e,
  BPopoverOrchestrator: _sfc_main$1f,
  BProgress: _sfc_main$1g,
  BProgressBar: _sfc_main$1h,
  BRow: _sfc_main$1i,
  BSpinner: _sfc_main$1j,
  BTab: _sfc_main$1k,
  BTable: _sfc_main$1l,
  BTableLite: _sfc_main$1m,
  BTableSimple: _sfc_main$1n,
  BTabs: _sfc_main$1o,
  BTbody: _sfc_main$1p,
  BTd: _sfc_main$1q,
  BTfoot: _sfc_main$1r,
  BTh: _sfc_main$1s,
  BThead: _sfc_main$1t,
  BToast: _sfc_main$1u,
  BToastOrchestrator: _sfc_main$1v,
  BTooltip: _sfc_main$1w,
  BTr: _sfc_main$1x
}, Symbol.toStringTag, { value: "Module" }));
export {
  index as i
};
//# sourceMappingURL=index-D4dAqwhl.mjs.map
